import React, { useContext } from 'react'
import { formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY } from '../../JS/Common'
import Popup from '../../Components/Popup';
import { ApiGetCDNData } from '../../JS/Connector';
import { useSelector } from 'react-redux';
import useConfig from '../../Hooks/useConfig';

function SoftwareInfo(props) {
    const itemData = props.EditData
    const { department } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const openPDFInNewTab = () => {
        ApiGetCDNData("/" + props.EditData.document, StateData?.Schoolnumber).then((blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        });
    };
    const modalBody = (
        <div className="row px-2">
            <div className="col-md-6 p-1 pe-0 ">
                <label className='FormLabel'>Name : &nbsp;</label><label className='fw-600'>{itemData.name}</label>
            </div>
            <div className="col-md-6 p-1 pe-0">
                <label className='FormLabel'>Purchase Date : &nbsp;</label><label className='fw-600'>{itemData.date_purchased ? formatDateToMMDDYYYY(itemData.date_purchased) : '-'}</label>
            </div>
            <div className="col-md-6 p-1 pe-0">
                <label className='FormLabel'>Length of Licenses : &nbsp;</label><label className='fw-600'>{itemData.license_length}</label>
            </div>
            <div className="col-md-6 p-1 pe-0">
                <label className='FormLabel'>License Renewal : &nbsp;</label><label className='fw-600'>{itemData.license_renewal ? formatDateToMMDDYYYY(itemData.license_renewal) : ''}</label>
            </div>
            <div className="col-md-6 p-1 pe-0">
                <label className='FormLabel'>Cost : &nbsp;</label><label className='fw-600'>${itemData.cost}</label>
            </div>
            <div className="col-md-6 p-1 pe-0">
                <label className='FormLabel'>Building Used For : &nbsp;</label><label className='fw-600'>{itemData.buildings}</label>
            </div>
            <div className="col-md-6 p-1 pe-0">
                <label className='FormLabel'>Quantity : &nbsp;</label><label className='fw-600'>{itemData.license_qty}</label>
            </div>
            <div className="col-md-6 p-1 pe-0">
                <label className='FormLabel'>{department} : &nbsp;</label><label className='fw-600'>{itemData.grade || '-'}</label>
            </div>
            <div className="col-md-6 p-1 pe-0 ">
                <label className='FormLabel'>Subject : &nbsp;</label><label className='fw-600'>{itemData.subject || '-'}</label>
            </div>
            <div className="col-md-6 p-1 pe-0 ">
                <label className='FormLabel'>Document : &nbsp;</label><label className='fw-600'>
                    {itemData.document != null ?
                        <>
                            <label className="mt-1" style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>{itemData.document} </label>
                            <img src='/images/eyeicon.svg' title="Show Software Details" className='pe-2 cursor-pointer' onClick={(e) => openPDFInNewTab(e)} />
                        </>
                        :
                        '-'}
                </label>
            </div>
            <div className="col-12 p-1 pe-0 ">
                <label className='FormLabel'>Notes : &nbsp;</label>
                <div className="fw-600"> {itemData.notes || '-'}</div>
            </div>
        </div>
    )
    return (
        <Popup isshow={props.isShow} size={"md"} title={"Software Details"}
            closePopup={props.ClosePopup} modalBody={modalBody} visibleSaveBtn={false} />
    )
}

export default SoftwareInfo
